<div *ngIf="userLeavesDetails">
    <div class="scrollbar app px-0">
        <div class="card-header">
            <div class="d-flex justify-content-end">
                <button type="button" (click)="onAdd()" type="reset" class="btn btn-primary" aria-label="Center Align"
                    translate>lblAddLeave</button>
            </div>
        </div>
        <div class="pad15 pt-0">
            <div class="table-responsive tableMx-15">
                <table class="tablest1">
                    <thead>
                        <tr>
                            <th style="width: 5%" scope="col" translate>#</th>
                            <th style="width: 10%" scope="col" translate>lblLeaveOption</th>
                            <th style="width: 10%" scope="col" translate>lblLeaveType</th>
                            <th style="width: 20%" scope="col" translate>lblStartDate</th>
                            <th style="width: 20%" scope="col" translate>lblEndDate</th>
                            <th style="width: 60%" scope="col" translate>lblRemark</th>
                            <th style="width: 55%" scope="col" translate>lblDays</th>
                            <th style="width: 30%" scope="col" translate>lblAbsenceHour</th>
                            <th style="width: 120px" class="text-center" scope="col" translate>lblAction</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="leavesList?.length>0; else load_else">
                            <tr *ngFor="let leave of leavesList; let i=index">
                                <td>{{leave.rowNumber}}</td>
                                <td>{{leave.option}}</td>
                                <td>{{leave.leaveType}}</td>
                                <td>{{leave.startDate | date:'short'}}</td>
                                <td>{{leave.endDate | date:'short'}}</td>
                                <td>{{leave.remark}}</td>
                                <td>{{leave.selectedDays}}</td>
                                <td>{{leave.absenceHour}}</td>
                                <td class="nowrap text-center">
                                    <ng-container *ngIf="(leave.leaveTypeId!==2);else leaveType">
                                        <a class="btn btn-ico" ngbTooltip="Edit" tooltipClass="custom-revert"
                                            (click)="onEdit(leave)">
                                            <em class="fas fa-pencil-alt fa-lg"></em>
                                        </a>
                                    </ng-container>
                                    <ng-container>
                                        <span class="ico-div"></span>
                                        <a class="btn btn-ico" ngbTooltip="Delete" tooltipClass="custom-revert"
                                            (click)="DeleteLeave(leave.id)">
                                            <em class="far fa-trash-alt fa-lg"></em>
                                        </a>
                                    </ng-container>
                                    <ng-template #leaveType>
                                        <a class="btn btn-ico disabled" ngbTooltip="Edit" tooltipClass="custom-revert">
                                            <em class="fas fa-pencil-alt fa-lg"></em>
                                        </a>
                                    </ng-template>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-template #load_else>
                            <tr>
                                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>
            </div>
            <div class="card-footer px-0">
                <div class="d-flex justify-content-between">
                    <ngb-pagination [collectionSize]="paggerService.total$  | async" [(page)]="paggerService.page"
                        [pageSize]="paggerService.pageSize" [maxSize]="3">
                    </ngb-pagination>
                    <select class="custom-select" style="width: auto" name="pageSize" [(ngModel)]="paggerService.pageSize">
                        <option *ngFor="let item of paggerService.pageItemsArray" [ngValue]="item.values" translate>
                            {{item.label}}
                        </option>
                    </select>
                </div>
            </div>
        </div>

    </div>
    <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
            <div _ngcontent-suh-c228="" class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15 mr-5">
                <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
            </div>
        </div>
    </div>
</div>


<div *ngIf="addUserLeave">
    <form #f="ngForm" (ngSubmit)="AddUserLeaves(userLeaves)">
        <div class="scrollbar app">
            <div class="row">
                <label class="col-12" style="margin-right:26px;" translate
                    *ngIf="!isLeaveTypeHidden">lblLeaveOption</label>
                <label class="col-12" style="margin-right:26px;" translate
                    *ngIf="isLeaveTypeHidden">lblLeaveType</label>
                <div class="mb-2 col-12" style="margin-right:26px ;" *ngIf="!isLeaveTypeHidden">
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="Personal" [(ngModel)]="userLeaves.option" [value]=1
                                name="leaveOptionType" class="radio-custom" [ngModelOptions]="{standalone: true}" />
                            <label class="form-check-label" style="line-height: 25px;" for="OptionType"
                                translate>lblPersonal</label>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="Business" [(ngModel)]="userLeaves.option" [value]=2
                                name="leaveOptionType" class="radio-custom" [ngModelOptions]="{standalone: true}" />
                            <label class="form-check-label" style="line-height: 25px;" for="OptionType"
                                translate>lblBusiness</label>
                        </div>
                    </div>

                </div>
                <div class="mb-2 col-12" style="margin-right:26px ;" *ngIf="isLeaveTypeHidden">
                    <div class="col-auto" *ngFor="let leaveType of customLeaveType">
                        <div class="  p-0">
                            <input type="radio" [id]="leaveType.id" [(ngModel)]="userLeaves.option"
                                [value]="leaveType.value" name="leaveOptionType" class="radio-custom"
                                [ngModelOptions]="{standalone: true}" />
                            <label class="form-check-label" style="line-height: 25px;" for="OptionType"
                                translate>{{leaveType.name}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <label style="margin-right:26px ;" class="col-12" translate
                    *ngIf="!isLeaveTypeHidden">lblLeaveType</label>
                <div class="mb-2 col-12" style="margin-right:26px ;" *ngIf="!isLeaveTypeHidden">
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="DateRange" [(ngModel)]="userLeaves.leaveType" [value]=1
                                name="leaveType" class="radio-custom" [ngModelOptions]="{standalone: true}"
                                (change)="LeaveTypeChange()" />
                            <label class="form-check-label" style="line-height: 25px;" for="DateRange"
                                translate>lblDateRange</label>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="MultiDays" [(ngModel)]="userLeaves.leaveType" [value]=2
                                name="leaveType" class="radio-custom" [ngModelOptions]="{standalone: true}"
                                (change)="LeaveTypeChange()" />
                            <label class="form-check-label" style="line-height: 25px;" for="DateRange"
                                translate>lblMultiDays</label>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="Recurring" [(ngModel)]="userLeaves.leaveType" [value]=3
                                name="leaveType" class="radio-custom" [ngModelOptions]="{standalone: true}"
                                (change)="LeaveTypeChange()" />
                            <label class="form-check-label" style="line-height: 25px;" for="DateRange"
                                translate>lblRecurring</label>
                        </div>
                    </div>

                </div>
                <ng-container *ngIf="userLeaves.leaveType == 1 || isLeaveTypeHidden" class="col-12"
                    style="margin-top: 100px;">
                    <!--Start Date-->
                    <div class="col-3 af-form-group">
                        <label for="template-edit-startDate" translate>lblStartDate<strong class="mlt6 required"> *
                            </strong></label>
                        <div class="lbl-info date">
                            <input class="form-control datePicker width100force" appAfDatepicker
                                [ngModelOptions]="{standalone: true}" [dateTime]="true"
                                [(ngModel)]="userLeaves.startDate" [defaultTime]="'00:00'"
                                [disableNextMonthDates]="true" readonly [isOnlyTime]="false">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                    <!--End Date-->
                    <div class="col-3 af-form-group">
                        <label for="template-edit-endDate" translate>lblEndDate<strong class="mlt6 required"> *
                            </strong></label>
                        <div class="lbl-info date">
                            <input class="form-control datePicker width100force" appAfDatepicker
                                [ngModelOptions]="{standalone: true}" [dateTime]="true" [isOnlyTime]="false" readonly
                                [defaultTime]="'00:00'" [disableNextMonthDates]="true" [(ngModel)]="userLeaves.endDate">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="userLeaves.leaveType == 2" style="margin-top: 100px;">
                    <div class="col-3 af-form-group">

                        <div class="lbl-info date">
                            <input class=" datePicker width100force" [isInline]="true" appAfDatepicker
                                [ngModelOptions]="{standalone: true}" [dateTime]="false" [isOnlyTime]="false" readonly
                                [disableNextMonthDates]="true" (OnSelect)="OnDateChanged($event)">



                        </div>
                    </div>
                    <div class="col-1">

                    </div>
                    <div class="col-4" *ngIf="userLeaves.multiDateList?.length>0">
                        <div class="table-responsive tableMx-15">
                            <table style=" border: 0.5px solid #d7d0d0;
                                                border-collapse: collapse;" class="tablest1">
                                <thead>
                                    <tr>
                                        <th style="width: 60%" scope="col" translate>lblSelectedDate</th>
                                        <th style="width: 50px" class="text-center" scope="col" translate>lblAction</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="userLeaves.multiDateList?.length>0;">
                                        <tr *ngFor="let leave of userLeaves.multiDateList; let i=index">
                                            <td>{{leave.endDate | date:'shortDate'}}</td>

                                            <td class="nowrap text-center">
                                                <ng-container>
                                                    <a class="btn btn-ico" ngbTooltip="Delete"
                                                        tooltipClass="custom-revert"
                                                        (click)="DeleteMultiDateLeave(leave,i)">
                                                        <em class="far fa-trash-alt fa-lg"></em>
                                                    </a>
                                                </ng-container>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="userLeaves.leaveType == 3" class="col-12" style="margin-top: 100px;">
                    <!--Start Date-->
                    <div class="col-3 af-form-group">
                        <label for="template-edit-startDate" translate>lblStartDate<strong class="mlt6 required"> *
                            </strong></label>
                        <div class="lbl-info date">
                            <input class="form-control datePicker width100force" appAfDatepicker
                                [ngModelOptions]="{standalone: true}" [dateTime]="true"
                                [(ngModel)]="userLeaves.startDate" [defaultTime]="recurringDefaultStartTime"
                                [disableNextMonthDates]="true" readonly [isOnlyTime]="false">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                    <!--End Date-->
                    <div class="col-3 af-form-group">
                        <label for="template-edit-endDate" translate>lblEndDate<strong class="mlt6 required"> *
                            </strong></label>
                        <div class="lbl-info date">
                            <input class="form-control datePicker width100force" appAfDatepicker
                                [ngModelOptions]="{standalone: true}" [dateTime]="true" [isOnlyTime]="false" readonly
                                [defaultTime]="recurringDefaultEndTime" [disableNextMonthDates]="true"
                                [(ngModel)]="userLeaves.endDate">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>

                    <div class="mb-2 mt-2 col-12 ">
                        <div class="row">
                            <div class="col-auto d-flex">
                                <div class="col-auto">
                                    <label class="form-check-label " style="line-height: 25px;" for="OptionType"
                                        translate>lblEvery</label>
                                </div>
                                <div class="col-auto">
                                    <input type="number" value="" class="text-right  form-control " style="width: 70px;"
                                        [(ngModel)]="userLeaves.recurring" (change)="checkRecurring()" min="1" max="99"
                                        disable maxlength="3" [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div class="col-auto">
                                    <label class="form-check-label  ml-0" style="line-height: 25px;" for="OptionType"
                                        translate>lblWeekOn</label>
                                </div>
                            </div>
                            <div class="col-8">
                                <ul>
                                    <ng-container *ngIf="this.weekDays">
                                        <li *ngFor="let item of this.weekDays;let i=index" class="mb-1">
                                            <ng-container>
                                                <span class="d-flex align-items-center form-check mr-2 ms-auto ml-2">
                                                    <input type="checkbox" id="showAll" class="form-check-input mt-0"
                                                        [(ngModel)]="item.isSelected"
                                                        (change)="onDaySelected(item,$event)"
                                                        [ngModelOptions]="{standalone: true}" />
                                                    <label class="form-check-label text-dark bold day ml-3" for=""
                                                        translate>{{item.name |
                                                        translate}}</label>
                                                </span>
                                            </ng-container>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </div>
                    </div>

                </ng-container>
                <div class="mb-2 col-12" style="margin-right:26px ;">
                    <div class="col-6">
                        <div class="p-0">

                            <label class="form-check-label" style="line-height: 25px;" for="DateRange"
                                translate>lblRemark<strong class="mlt6 required"> *
                                </strong></label>
                            <textarea class="form-control customize-textbox " [(ngModel)]="userLeaves.remark"
                                maxlength="200" [ngModelOptions]="{standalone: true}">
                                                                            </textarea>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
            <div class="row">
                <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                    <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align"
                        [disabled]="!f.valid" translate>lblAdd</button>
                    <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="editUserLeave">
    <form #f="ngForm" (ngSubmit)="editUserLeaves(userLeaves)">
        <div class="scrollbar app">
            <div class="row">
                <label class="" style="margin-right:26px ;" translate *ngIf="!isLeaveTypeHidden">lblLeaveOption</label>
                <label class="" style="margin-right:26px;" translate *ngIf="isLeaveTypeHidden">lblLeaveType</label>
                <div class="mb-2 col-12" style="margin-right:26px ;" *ngIf="!isLeaveTypeHidden">
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="Personal" [(ngModel)]="userLeaves.option" [value]=1
                                name="leaveOptionType" class="radio-custom" [ngModelOptions]="{standalone: true}"
                                [disabled]=true />
                            <label class="form-check-label" style="line-height: 25px;" for="OptionType"
                                translate>lblPersonal</label>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="Business" [(ngModel)]="userLeaves.option" [value]=2
                                name="leaveOptionType" class="radio-custom" [ngModelOptions]="{standalone: true}"
                                [disabled]=true />
                            <label class="form-check-label" style="line-height: 25px;" for="OptionType"
                                translate>lblBusiness</label>
                        </div>
                    </div>

                </div>
                <div class="mb-2 col-12" style="margin-right:26px ;" *ngIf="isLeaveTypeHidden">
                    <div class="col-auto" *ngFor="let leaveType of customLeaveType">
                        <div class="  p-0">
                            <input type="radio" [id]="leaveType.id" [(ngModel)]="userLeaves.option"
                                [value]="leaveType.value" name="leaveOptionType" class="radio-custom"
                                [ngModelOptions]="{standalone: true}" [disabled]=true />
                            <label class="form-check-label" style="line-height: 25px;" for="OptionType"
                                translate>{{leaveType.name}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <label style="margin-right:26px ;" class="" translate *ngIf="!isLeaveTypeHidden">lblLeaveType</label>
                <div class="mb-2 col-12" style="margin-right:26px ;" *ngIf="!isLeaveTypeHidden">
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="DateRange" [(ngModel)]="userLeaves.leaveType" [value]=1
                                name="leaveType" class="radio-custom" [ngModelOptions]="{standalone: true}"
                                (change)="LeaveTypeChange()" [disabled]=true />
                            <label class="form-check-label" style="line-height: 25px;" for="DateRange"
                                translate>lblDateRange</label>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="MultiDays" [(ngModel)]="userLeaves.leaveType" [value]=2
                                name="leaveType" class="radio-custom" [ngModelOptions]="{standalone: true}"
                                (change)="LeaveTypeChange()" [disabled]=true />
                            <label class="form-check-label" style="line-height: 25px;" for="DateRange"
                                translate>lblMultiDays</label>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="  p-0">
                            <input type="radio" id="Recurring" [(ngModel)]="userLeaves.leaveType" [value]=3
                                name="leaveType" class="radio-custom" [ngModelOptions]="{standalone: true}"
                                (change)="LeaveTypeChange()" [disabled]=true />
                            <label class="form-check-label" style="line-height: 25px;" for="DateRange"
                                translate>lblRecurring</label>
                        </div>
                    </div>

                </div>
                <ng-container *ngIf="userLeaves.leaveType == 1 || isLeaveTypeHidden" class="col-12"
                    style="margin-top: 100px;">
                    <!--Start Date-->
                    <div class="col-3 af-form-group" *ngIf="userLeaves.startDate">
                        <label for="template-edit-startDate" translate>lblStartDate<strong class="mlt6 required"> *
                            </strong></label>
                        <div class="lbl-info date">
                            <input class="form-control datePicker width100force" [startDate]="'1900/01/01'"
                                appAfDatepicker [ngModelOptions]="{standalone: true}" [dateTime]="true"
                                [(ngModel)]="userLeaves.startDate" [disableNextMonthDates]="true" [isOnlyTime]="false">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                    <!--End Date-->
                    <div class="col-3 af-form-group" *ngIf="userLeaves.endDate">
                        <label for="template-edit-endDate" translate>lblEndDate<strong class="mlt6 required"> *
                            </strong></label>
                        <div class="lbl-info date">
                            <input class="form-control datePicker width100force" [startDate]="'1900/01/01'"
                                appAfDatepicker [ngModelOptions]="{standalone: true}" [dateTime]="true"
                                [isOnlyTime]="false" [disableNextMonthDates]="true" [(ngModel)]="userLeaves.endDate">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="userLeaves.leaveType == 2" style="margin-top: 100px;">
                    <div class="col-3 af-form-group">
                        <div class="lbl-info date">
                            <input class=" datePicker width100force" [isInline]="true" appAfDatepicker
                                [ngModelOptions]="{standalone: true}" [dateTime]="false" [isOnlyTime]="false" readonly
                                [disableNextMonthDates]="true" (OnSelect)="OnDateChanged($event)">
                        </div>
                    </div>
                    <div class="col-1">
                    </div>
                    <div class="col-4" *ngIf="userLeaves.multiDateList?.length>0">
                        <div class="table-responsive tableMx-15">
                            <table style=" border: 0.5px solid #d7d0d0;
                                border-collapse: collapse;" class="tablest1">
                                <thead>
                                    <tr>
                                        <th style="width: 60%" scope="col" translate>lblSelectedDate</th>
                                        <th style="width: 50px" class="text-center" scope="col" translate>lblAction</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="userLeaves.multiDateList?.length>0;">
                                        <tr *ngFor="let leave of userLeaves.multiDateList; let i=index">
                                            <td>{{leave.startDate | date:'shortDate'}}</td>

                                            <td class="nowrap text-center">
                                                <ng-container>
                                                    <a class="btn btn-ico" ngbTooltip="Delete"
                                                        tooltipClass="custom-revert"
                                                        (click)="DeleteMultiDateLeave(leave,i)">
                                                        <em class="far fa-trash-alt fa-lg"></em>
                                                    </a>

                                                </ng-container>

                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="userLeaves.leaveType == 3" class="col-12" style="margin-top: 100px;">
                    <!--Start Date-->
                    <div class="col-3 af-form-group">
                        <label for="template-edit-startDate" translate>lblStartDate<strong class="mlt6 required"> *
                            </strong></label>
                        <div class="lbl-info date">
                            <input class="form-control datePicker width100force" [startDate]="'1900/01/01'"
                                appAfDatepicker [ngModelOptions]="{standalone: true}" [dateTime]="true"
                                [(ngModel)]="userLeaves.startDate" [defaultTime]="'00:00'"
                                [disableNextMonthDates]="true" [isOnlyTime]="false">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                    <!--End Date-->
                    <div class="col-3 af-form-group">
                        <label for="template-edit-endDate" translate>lblEndDate<strong class="mlt6 required"> *
                            </strong></label>
                        <div class="lbl-info date">
                            <input class="form-control datePicker width100force" [startDate]="'1900/01/01'"
                                appAfDatepicker [ngModelOptions]="{standalone: true}" [dateTime]="true"
                                [isOnlyTime]="false" [defaultTime]="'00:00'" [disableNextMonthDates]="true"
                                [(ngModel)]="userLeaves.endDate">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>

                    <div class="mb-2 mt-2 col-12 ">
                        <div class="row">
                            <div class="col-auto d-flex">
                                <div class="col-auto">
                                    <label class="form-check-label " style="line-height: 25px;" for="OptionType"
                                        translate>lblEvery</label>
                                </div>
                                <div class="col-auto">
                                    <input type="number" value="" class="text-right  form-control " style="width: 70px;"
                                        [(ngModel)]="userLeaves.recurring" (change)="checkRecurring()" min="1" max="99"
                                        maxlength="3" [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div class="col-auto">
                                    <label class="form-check-label  ml-0" style="line-height: 25px;" for="OptionType"
                                        translate>lblWeekOn</label>
                                </div>
                            </div>
                            <div class="col-8">
                                <ul>
                                    <ng-container *ngIf="this.weekDays">
                                        <li *ngFor="let item of this.weekDays;let i=index" class="mb-1">
                                            <ng-container>
                                                <span class="d-flex align-items-center form-check mr-2 ms-auto ml-2">
                                                    <input type="checkbox" id="showAll" class="form-check-input mt-0"
                                                        [(ngModel)]="item.isSelected"
                                                        (change)="onDaySelected(item,$event)"
                                                        [ngModelOptions]="{standalone: true}" />
                                                    <label class="form-check-label text-dark bold day ml-3" for=""
                                                        translate>{{item.name |
                                                        translate}}</label>
                                                </span>
                                            </ng-container>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="mb-2 col-12" style="margin-right:26px ;">
                    <div class="col-6">
                        <div class="p-0">
                            <label class="form-check-label" style="line-height: 25px;" for="DateRange"
                                translate>lblRemark<strong class="mlt6 required"> *
                                </strong></label>
                            <textarea class="form-control customize-textbox " [(ngModel)]="userLeaves.remark"
                                maxlength="200" [ngModelOptions]="{standalone: true}">
                                                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
            <div class="row">
                <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                    <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align"
                        [disabled]="!f.valid" translate>lblSave</button>
                    <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                </div>
            </div>
        </div>
    </form>
</div>